import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasCategoryContext;

export interface CategoryDetailLinkListStyles {
    container?: GridContainerProps;
    subCategoryNameLinkItem?: GridItemProps;
    subCategoryNameLink?: LinkPresentationProps;
}

export const categoryDetailLinkListStyles: CategoryDetailLinkListStyles = {
    container: {
        gap: 0,
    },
    subCategoryNameLinkItem: {
        width: 12,
        css: css`
            padding-bottom: 10px;
        `,
    },
};

const styles = categoryDetailLinkListStyles;

const CategoryDetailLinkList = ({ category }: Props) => {
    if (!category || !category.subCategoryIds || category.subCategoryIds.length === 0) {
        return null;
    }

    return (
        <GridContainer {...styles.container}>
            {category.subCategoryIds.map(subCategoryId => (
                <SubCategoryLink key={subCategoryId.toString()} subCategoryId={subCategoryId} />
            ))}
            {/* {category.shortDescription.toLowerCase() === "rugs" && (
                <GridItem {...styles.subCategoryNameLinkItem}>
                    <Link
                        href={`${siteMessage("DesignYourOwnRug_Link")}`}
                        {...styles.subCategoryNameLink}
                        data-test-selector="categoryDetailsLinkListLink_DesignYourOwnRug"
                    >
                        {translate("Design Your Own Rug")}
                    </Link>
                </GridItem>
            )} */}
        </GridContainer>
    );
};

const mapStateToProps = (state: ApplicationState, ownProps: { subCategoryId: string }) => {
    return {
        category: getCategoryState(state, ownProps.subCategoryId).value,
    };
};

const SubCategoryLinkView = ({ category }: ReturnType<typeof mapStateToProps>) => {
    if (!category || category.properties?.hideFromLanding === "true") {
        return null;
    }

    return (
        <GridItem  {...styles.subCategoryNameLinkItem}>
            <Link
                href={category.path}
                {...styles.subCategoryNameLink}
                data-test-selector={`categoryDetailsLinkListLink_${category.id}`}
            >
                {category.shortDescription}
            </Link>
        </GridItem>

    );
};

const SubCategoryLink = connect(mapStateToProps)(SubCategoryLinkView);

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDetailLinkList),
    definition: {
        group: "Category Details",
        icon: "list-ul",
        allowedContexts: ["CategoryDetailsPage"],
    },
};

export default widgetModule;
